import base from "./base.service";

const getBucketUrl = payload => base.get(`/util/uploadFile?location=${payload?.location}&extension=${payload?.extension}`);

const uploadFile = payload => fetch(payload?.url, payload?.requestOptions);

const getContractAgreement = () => base.get('/users/downloadContractAgreement');
const contactUs = payload=>base.post('/util/contactUs',payload)

export const utilService = {
    getBucketUrl,
    uploadFile,
    getContractAgreement,
    contactUs
}